import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {MatLegacyPaginator as MatPaginator} from '@angular/material/legacy-paginator';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {AuthService} from '../../services/auth.service';
import {EnvService} from '../../services/env.service';
import {SettingsPersistenceService} from '../../services/settings-persistence.service';
import {ManagedCommandFilter} from './managedCommand.filter';
import {debounceTime} from 'rxjs/operators';

@Component({
  selector: 'micro-managed-commands',
  templateUrl: './managedCommands.component.html'
})
export class ManagedCommandsComponent implements OnInit, OnDestroy {

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  filter: ManagedCommandFilter = new ManagedCommandFilter();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  pageSettings: SettingsPersistenceService;
  isAdmin: boolean;
  focusCompanyId: string | undefined;

  constructor(protected auth: AuthService,
              private env: EnvService,
              private http: HttpClient) {
    this.isAdmin = this.auth.isCompanyAdmin();
  }

  ngOnInit() {
    this.pageSettings = new SettingsPersistenceService(sessionStorage, 'micro.managedCommands');
    this.pageSettings
      .setFilter(this.filter)
      .setPaginator(this.paginator)
      .init();

    this.filter.anyChange.pipe(debounceTime(500)).subscribe(() => {
      this.reload();
    });

    this.reload();
  }

  ngOnDestroy() {
  }

  reload() {
    const params: HttpParams = this.filter.getParams()
      .set('page', '' + (this.paginator.pageIndex || 0))
      .set('size', '' + (this.paginator.pageSize || this.pageSettings.defaultPageSize));

    this.http.get(`${this.env.e.url}/cmd/managed`, {params: params}).subscribe(
      data => {
        const page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
      }
    );
  }
}
